export default "__VITE_ASSET__BuI9RKzu__"